module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/m1-ca82423746ec53d732d252c26d1a0f4c.svg";